let isActive = false;
let emailAddress = null;
let phoneNumber = null;
let nip = null;
let agreement = false;
let outputMessage = null;
let submitedFormId
let baseForm;
let isFormSubmitting = false;

const file = {
    nameFirst: "",
    nameSecond: " Dopuszczalne rozszerzenia: jpg, png, pdf",
    size: 0,
    extension: null,
    maxSize: 10485760,
    content: null,
    limitFirst: "Maksymalny rozmiar 10 MB.",
    limitSecond: " Dopuszczalne rozszerzenia: jpg, png, pdf",
};

const errorMessages = {
    file: null,
    email: null,
    phone: null,
    nip: null,
    agreement: null
};

const validationErrors = [{
        "name": "file",
        "messages": {
            "msg0": "Proszę wybrać plik",
            "msg1": "Proszę wybrać plik w poprawnym formacie",
            "msg2": "Proszę wybrać plik o rozmiarze max. 10 MB",
            "msg3": "Proszę wybrać plik o rozmiarze max. 10 MB i w poprawnym formacie"
        }
    },
    {
        "name": "email",
        "messages": {
            "msg1": "Wprowadź poprawny adres email",
            "msg2": "Wprowadź co najmniej jedną daną kontaktową"
        }
    },
    {
        "name": "phone",
        "messages": {
            "msg1": "Wprowadź poprawny nr telefonu",
            "msg2": "Wprowadź co najmniej jedną daną kontaktową"
        }
    },
    {
        "name": "nip",
        "messages": {
            "msg1": "Wprowadź poprawny nr nip"
        }
    },
    {
        "name": "agreement",
        "messages": {
            "msg1": "Zaznacz zgody"
        }
    }
];

// OK
const schemaValidators = {
    email: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
    phone: /^\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/i,
    nip: /^\d{3}[ -]?\d{2}[ -]?\d{2}[ -]?\d{3}(?!\w)/i,
};

const formErrors = {
    phone: false,
    email: false,
    nip: false,
    agreement: false,
    file: false
};

// FIXED
function toggleStatute() {
    this.parentNode.querySelector('div').classList.toggle('active')
}


// SHOULD BE
function handleErrorFile() {




    if (file.nameFirst == null) {
        formErrors.file = true;
        errorMessages.file = validationErrors[0].messages['msg0'];
    } else if (
        ![".jpg", ".png", ".pdf"].includes(file.extension?.toLowerCase()) &&
        file.size > file.maxSize
    ) {
        formErrors.file = true;
        errorMessages.file = validationErrors[0].messages['msg3'];
    } else if (![".jpg", ".png", ".pdf"].includes(file.extension?.toLowerCase())) {
        formErrors.file = true;
        errorMessages.file = validationErrors[0].messages['msg1'];
    } else if (file.size > file.maxSize) {
        formErrors.file = true;
        errorMessages.file = validationErrors[0].messages['msg2'];
    } else {
        formErrors.file = false;
        errorMessages.file = null;
    }
    insertIntoErrorField('file', errorMessages.file)
}

// FIXED
function handleErrorEmailAndPhone() {
    if (schemaValidators.email.test(emailAddress)) formErrors.email = false;
    else formErrors.email = true;

    if (schemaValidators.phone.test(phoneNumber)) formErrors.phone = false;
    else formErrors.phone = true;

    if (formErrors.email && formErrors.phone)
        if (emailAddress !== null && phoneNumber !== null) {
            errorMessages.email = validationErrors[1].messages['msg1'];
            errorMessages.phone = validationErrors[2].messages['msg1'];
        } else if (emailAddress !== null) {
        errorMessages.email = validationErrors[1].messages['msg1'];
        errorMessages.phone = validationErrors[2].messages['msg2'];
    } else if (phoneNumber !== null) {
        errorMessages.phone = validationErrors[2].messages['msg1'];
        errorMessages.email = validationErrors[1].messages['msg2'];
    } else {
        errorMessages.email = validationErrors[1].messages['msg2'];
        errorMessages.phone = validationErrors[2].messages['msg2'];
    } else {
        errorMessages.email = null;
        errorMessages.phone = null;

    }
    insertIntoErrorField('email', errorMessages.email)
    insertIntoErrorField('phone', errorMessages.phone)
}

// FIXED
function handleErrorNip() {
    if (schemaValidators.nip.test(nip)) {
        formErrors.nip = false;
        errorMessages.nip = null;
        insertIntoErrorField('nip', errorMessages.nip)

    } else {
        formErrors.nip = true;
        errorMessages.nip = validationErrors[3].messages['msg1']
        insertIntoErrorField('nip', errorMessages.nip)
    }
}

// ADDED
function insertIntoErrorField(fieldName, notification) {
    // var baseForm = document.getElementById(submitedFormId);
    if (fieldName == 'agreement') {
        if (baseForm.querySelectorAll('input[name="' + fieldName + '"]').length > 0) {
            baseForm.querySelector('input[name="' + fieldName + '"]').nextSibling.nextSibling.innerText = notification
            baseForm.querySelector('input[name="' + fieldName + '"]').classList.add("invalid");
            if (notification == null) baseForm.querySelector('input[name="' + fieldName + '"]').classList.remove("invalid");
        }
    } else if (fieldName == 'file') {
        baseForm.querySelector('input[name="' + fieldName + '"]').previousElementSibling.innerText = notification
    } else {
        if (baseForm.querySelectorAll('input[name="' + fieldName + '"]').length > 0) {
            baseForm.querySelector('input[name="' + fieldName + '"]').parentElement.nextSibling.innerText = notification
            baseForm.querySelector('input[name="' + fieldName + '"]').classList.add("invalid");
            if (notification == null) baseForm.querySelector('input[name="' + fieldName + '"]').classList.remove("invalid");
        }
    }
}

// FIXED
function handleErrorAgreement() {
    if (agreement === true) {
        formErrors.agreement = false;
        errorMessages.agreement = null;
    } else {
        formErrors.agreement = true;
        errorMessages.agreement = validationErrors[4].messages['msg1'];
    }
    insertIntoErrorField('agreement', errorMessages.agreement)
}

// WITHOUT FILES TESTED
function handleErrors() {
    if (typeOfForm().toLowerCase().includes("file")) {
        handleErrorFile();
        handleErrorEmailAndPhone();
        handleErrorNip();
        handleErrorAgreement();

    } else if (typeOfForm().includes('callMe')) {
        handleErrorEmailAndPhone();
        handleErrorNip();
        handleErrorAgreement();
    } else {
        handleErrorFile();
        handleErrorEmailAndPhone();
        handleErrorNip();
        handleErrorAgreement();
    }
}

// OK
function typeOfForm() {
    return baseForm.id

}

// CallMe is Tested
function checkValidation() {
    
    if (typeOfForm().toLowerCase().includes('file')) {
        if (
            formErrors.file !== false ||
            formErrors.phone !== false ||
            formErrors.email !== false ||
            formErrors.nip !== false ||
            formErrors.agreement !== false
        ) {
            
            return false;
        }

    } else if (typeOfForm().includes('callMe')) {
        if (formErrors.phone !== false || formErrors.nip !== false || formErrors.agreement !== false) {
            
            return false;
        }
    }
    
    return true;

}

function prepareConsultingFormWithFileRequestPayload() {

    return new Promise((resolve, reject) => {
        if (typeOfForm().toLowerCase().includes('file')) {
            var reader = new FileReader();
            reader.onload = function(event) {
                var fileContent = event.target.result;
                var fileName = document.querySelector('input[name="file"]').files[0].name;
                file.content = fileContent; // Aktualizacja zawartości pliku
                file.nameFirst = fileName; // Aktualizacja nazwy pliku
                const payload = {
                    "marketing": {
                        "formName": typeOfForm(),
                        "fingerprint": obtainFingerprint(),
                        "marketingConsentGiven": agreement,
                        "details": {
                            "email": emailAddress,
                            "phone": phoneNumber,
                            "nip": nip,
                        },
                        "files": [{
                            "name": file.nameFirst,
                            "content": file.content,
                        }, ],
                    },
                };
                resolve(payload);
            };
            reader.readAsDataURL(document.querySelector('input[name="file"]').files[0]);
        } else {
            resolve({}); // lub null
        }
    });
}

function prepareConsultingFormWithFileRequestPayload_working() {

    if (typeOfForm().toLowerCase().includes('file')) {
        var payload = {
            marketing: {
                formName: typeOfForm(),
                fingerprint: obtainFingerprint(),
                marketingConsentGiven: agreement,
                details: {
                    email: emailAddress,
                    phone: phoneNumber,
                    nip: nip,
                },
                files: [{
                    name: file.nameFirst,
                    content: file.content,
                }, ],
            },
        };

        return payload
    }
}

// FIXED
function prepareConsultingFormWithoutFileRequestPayload() {
    return {
        marketing: {
            formName: typeOfForm(),
            fingerprint: obtainFingerprint(),
            marketingConsentGiven: agreement,
            details: {
                phone: phoneNumber,
                nip: nip,
            },
            files: [],
        },
    };
}

// FIXED
function showFormSendingNotice() {
    outputMessage = "Wysyłanie formularza w toku";
    baseForm.querySelector('#' + submitedFormId + ' #output-form').innerText = outputMessage
}

function showResponseErrorNotice() {
    var baseForm = document.getElementById(submitedFormId);
    const self = this;
    return function(error) {


        if (error.response?.status === 422) {
            outputMessage = "Formularz zawiera błędy - sprawdź poprawność wypełnionych pól";
            baseForm.querySelector('#output-form').innerText = outputMessage
        }
        if (error.response?.status === 409) {
            outputMessage = "Wysłanie kolejnego zgłoszenia nie jest teraz możliwe - spróbuj ponownie później";
            baseForm.querySelector('#output-form').innerText = outputMessage
        }
        if (String(error.response?.status).startsWith('5')) {
            outputMessage = 'Błąd serwera - spróbuj ponownie później';
            baseForm.querySelector('#output-form').innerText = outputMessage
        }
    };
}

function handleResponse(onSuccess = () => {}) {
    const self = this;
    return function(response) {
        if (response.status === 200 || response.status === 201) {
            clearForm();
            outputMessage = "Wiadomość została wysłana.";
            baseForm.querySelector('#output-form').innerText = outputMessage
            onSuccess();
        }
    };
}
// Wyczyść formularz
function clearForm() {
    document.getElementById(submitedFormId).reset();
    // Wyczyszczenie pola z plikiem
    if (baseForm.querySelectorAll('input[name="file"]').length > 0) {
        var fileInput = baseForm.querySelector('input[type="file"]');
        fileInput.value = ''; // Ustawienie wartości pola na pustą
    }
    const emptyFileNameContainer = document.querySelector('.empty-file-name-container');
    document.querySelector('.empty-file-name-container');
    emptyFileNameContainer.classList.remove('file-name-container')
    emptyFileNameContainer.innerHTML = `<span>${file.limitFirst}</span><br><span>${file.limitSecond}</span>`;
    file.nameFirst = null


    emailAddress = null;
    phoneNumber = null;
    nip = null;
    agreement = false;
    outputMessage = null;

}

// FIXED
function sendRequest() {

    if (typeOfForm().toLowerCase().includes('file')) {
        return prepareConsultingFormWithFileRequestPayload()
            .then(payloadData => {


                return axios({
                    method: "post",
                    url: 'https://app.finansowaniefaktur.pl' + "/api/marketing/forms",
                    data: payloadData,
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
                    },
                });
            });
    } else if (typeOfForm().includes('callMe')) {
        return axios({
            method: "post",
            url: 'https://app.finansowaniefaktur.pl' + "/api/marketing/forms",
            data: prepareConsultingFormWithoutFileRequestPayload(),
            withCredentials: true,
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
            },
        });
    }




}

// FIXED
function obtainFingerprint() {
    const self = this;
    FingerprintJS.load()
        .then(fp => fp.get({
            extendedResult: false
        }))
        .then(result => {


            return result.visitorId;
        });
}
// FIXED
function submitForm(e) {
    submitedFormId = e.id

    baseForm = document.getElementById(e.id)
    updateFieldsValues(e.id) // OK
    event.preventDefault(); // OK
    handleErrors();
    if (checkValidation()) {
        showFormSendingNotice();
        disableSubmitButton();
        sendRequest()
            .then(function(response) {
                handleResponse(enableSubmitButton)(response); // Obsługa odpowiedzi
            }) // Obsługa odpowiedzi
            .catch(function(error) {
                showResponseErrorNotice(error); // Wyświetlenie komunikatu o błędzie
                enableSubmitButton(); // Odblokowanie przycisku wysyłania formularza w przypadku błędu
            })
    }
}

// Funkcja do blokowania przycisku wysyłania formularza
function disableSubmitButton() {
    var submitButton = baseForm.querySelector('button.button.primary');
    submitButton.disabled = true;
}

// Funkcja do odblokowania przycisku wysyłania formularza
function enableSubmitButton() {
    var submitButton = baseForm.querySelector('button.button.primary');
    submitButton.disabled = false;
    hideFormSentMessage()
}
// Funkcja do ukrywania komunikatu o wysłanym formularzu po 5 sekundach
function hideFormSentMessage() {
    var outputForm = baseForm.querySelector('#output-form');
    setTimeout(function() {
        outputForm.innerText = '';
    }, 5000);
}

function updateFieldsValues(submitedFormId) {
    if (baseForm.querySelectorAll('input[name="email"]').length > 0) emailAddress = baseForm.querySelector('input[name="email"]').value;
    if (baseForm.querySelectorAll('input[name="phone"]').length > 0) phoneNumber = baseForm.querySelector('input[name="phone"]').value;
    if (baseForm.querySelectorAll('input[name="nip"]').length > 0) nip = baseForm.querySelector('input[name="nip"]').value;
    if (baseForm.querySelectorAll('input[name="agreement"]').length > 0) agreement = baseForm.querySelector('input[name="agreement"]').checked;
    if (baseForm.querySelector('input[name="file"]') !== null && document.querySelector('input[name="file"]').files.length > 0) {
        file.nameFirst = baseForm.querySelector('input[name="file"]').files[0].name
        file.content = baseForm.querySelector('input[name="file"]').files[0].content
        file.extension = "." + baseForm.querySelector('input[name="file"]').files[0].name.split('.')[1]
    }

}
//Preventing from reloading form
var forms = document.querySelectorAll("form");

function handleForm(event) {
    event.preventDefault();
}
forms.forEach(form => form.addEventListener('submit', handleForm));